import React, { useEffect, useState } from 'react';
import { IoMdSearch } from 'react-icons/io';
import { useSelector } from 'react-redux';

const SearchBox = (props) => {
	const [ searchText, setSearchText ] = useState('');
	return (
		<div
			style={{
				padding: '0 10px'
			}}
		>
			<div className="searchInputContainer">
				<input
					className="searchInput"
					placeholder={'rechercher les produits, marques, boutiques et plus'}
					onChange={(e) => setSearchText(e.target.value)}
					value={searchText}
				/>
				<div className="searchIconContainer" onChange={props.handleSearch}>
					<IoMdSearch
						style={{
							color: 'rgb(7,155,155)',
							width: '30px',
							height: '30px'
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default SearchBox;
